import SORTING_TASK from './sorting-task'
export default {
	'sorting-task': SORTING_TASK
}
